const Cookie = {
  install (Vue) {
    Vue.prototype.$cookie = {
      get (name) {
        const nameEQ = name + '='
        const ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i]
          while (c.charAt(0) === ' ') c = c.substring(1, c.length)
          if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
        }
        return null
      },
      set (name, value) {
        document.cookie = `${name}=${value};path=/`
      },
      remove (name) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
      }
    }
  }
}

export default Cookie



// WEBPACK FOOTER //
// ./src/assets/js/Cookie.js